<template>
  <div>
    <h2>Listagem Posições de Ativos</h2>

    <v-data-table
      :headers="headers"
      :items="data"
      :page.sync="page"
      :sort-by.sync="sortBy"
      :items-per-page="data.length"
      :loading="isLoading"
      hide-default-footer
      disable-sort
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field 
            v-model="searchFilter.query"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <template v-slot:footer>
        <div class="table-footer">
          <span class="mr-4" v-if="total > 0"
            >Exibindo {{ from }} - {{ to }} de {{ total }}
          </span>
        </div>
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="totalPages"></v-pagination>
    </div>
  </div>
</template>


<script>
import { mapMutations } from 'vuex';
import Api from '../../services/api.service';

export default {
  name: 'Users',
  data: () => ({
    data: [],
    headers: [
      { text: 'Ativo', value: 'ativo' },
      { text: 'Usuário', value: 'usuario' },
      { text: 'Saldo Atual (Qtde)', value: 'saldo_atual_qtde' },
      { text: 'Valor Atual (R$)', value: 'valor_atual' },
      { text: 'Saldo Atual Financeiro', value: 'saldo_atual_financeiro' },
    ],
    isLoading: true,
    page: 1,
    page_atual: 1,
    perPage: 8,
    searchFilter: {
      query: null,
    },
    sortBy: 'id',
    to: 0,
    total: 0,
    totalPages: 0,
  }),
  filters: {
    formatList(list) {
      return list.map(e => e.name).sort().join(', ') 
    }
  },
  watch: {
    page: function () {
      if(this.page != this.page_atual)
      this.loadData();
    },
    searchFilter: {
      handler () {
        this.page = 1;
        this.loadData();
      },
      deep: true,
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapMutations(["showSnackbar"]),


    loadData () {
      this.isLoading = true;

      const params = {
        page: this.page,
        perPage: this.perPage,
        sort: this.sortBy,
      };

      if (this.searchFilter.query) 
        params['filter[nameOrEmail]'] = this.searchFilter.query;

      

      Api.get('positionActivesList', {params}).then(({ data }) => {
          const { from, to, total, data: items, current_page } = data;
          this.data = items.data;
          this.page_atual = current_page;
          this.from = from;
          this.to = to;
          this.total = total;
          this.totalPages = Math.ceil(this.total/this.perPage);

        })
        .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
        .finally(() => setTimeout(() => (this.isLoading = false), 300));


    },
  },
}
</script>
